module.exports = __webpack_public_path__ + "img/icon_alternative_location_catalog.1da98b59.svg";